import { faMinus, faPlus, faRadiation, faRecycle, faRotate, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Tilt from 'react-parallax-tilt';

interface TileViewProps {
    show: boolean;
    handleClose: () => void;
    specificProductData: any;
}

const TileView: React.FC<TileViewProps> = ({
    show,
    handleClose,
    specificProductData
}) => {
    const [zoom, setZoom] = useState(1);
    const [zoomInterval, setZoomInterval] = useState<NodeJS.Timeout | null>(null);
    const [isRotated, setIsRotated] = useState(false);
    const [rotation, setRotation] = useState(0);
    const imageRef = React.useRef<HTMLImageElement>(null);

    const toggleRotation = () => {
        const img = imageRef.current;
        if (img) {
            const { naturalWidth, naturalHeight } = img;
            if (naturalWidth > naturalHeight) {
                setRotation(prev => (prev === 0 ? 90 : 0));
            } else {
                setRotation(prev => (prev === 0 ? 90 : 0));
            }
        }
    };

    const handleZoomOut = () => {
        setZoom(prev => Math.max(0.5, prev - 0.1));
    };

    const handleZoomIn = () => {
        setZoom(prev => Math.min(3, prev + 0.1));
    };

    const startZooming = (type: "in" | "out") => {
        const interval = setInterval(() => {
            type === "in" ? handleZoomIn() : handleZoomOut();
        }, 100);
        setZoomInterval(interval);
    };

    const stopZooming = () => {
        if (zoomInterval) {
            clearInterval(zoomInterval);
            setZoomInterval(null);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} fullscreen>
            <div
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    zIndex: 1050,
                }}
            >
                <button
                    type="button"
                    className="bg-transparent border-0"
                    aria-label="Close"
                    onClick={handleClose}
                >
                    <FontAwesomeIcon icon={faXmark} style={{ color: 'white' }} size="xl" />
                </button>
            </div>

            <Modal.Body className="d-flex flex-column justify-content-center align-items-center tile-view-3d-background">
                <Tilt
                    scale={1.15}
                    tiltMaxAngleX={15}
                    tiltMaxAngleY={15}
                    perspective={1000}
                    transitionSpeed={2500}
                    gyroscope={true}
                    style={{ cursor: "grab" }}
                >
                    <div
                        style={{
                            transform: `rotate(${rotation}deg) scale(${zoom})`,
                            transition: "transform 0.3s ease-in-out",
                            transformOrigin: 'center',
                        }}
                    >
                        <img
                            ref={imageRef}
                            src={specificProductData?.image_url}
                            alt={specificProductData?.product_name_slug}
                            className="img-fluid"
                            style={{
                                maxWidth: '50vw',
                                height: 'auto',
                                width: 'auto',
                                maxHeight: '70vh',
                                objectFit: 'contain',
                            }}
                        />
                    </div>
                </Tilt>

                <div
                    className="zoom-controls-mobile"
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        left: "0",
                        right: "0",
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        zIndex: 1000,
                    }}
                >
                    <button
                        className="custom-btn-theme-color px-4"
                        onClick={handleZoomIn}
                        onMouseDown={() => startZooming("in")}
                        onMouseUp={stopZooming}
                        onMouseLeave={stopZooming}
                        onTouchStart={() => startZooming("in")}
                        onTouchEnd={stopZooming}
                        title='Zoom In'
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </button>

                    <button
                        className="custom-btn-theme-color ms-2 px-4"
                        onClick={handleZoomOut}
                        onMouseDown={() => startZooming("out")}
                        onMouseUp={stopZooming}
                        onMouseLeave={stopZooming}
                        onTouchStart={() => startZooming("out")}
                        onTouchEnd={stopZooming}
                        title='Zoom Out'
                    >
                        <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <button
                        className="custom-btn-theme-color ms-2 px-4"
                        onClick={toggleRotation}
                        title='Rotate'
                    >
                        <FontAwesomeIcon icon={faRotate} />
                    </button>

                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TileView;

